module.exports = "https://r.nearpod.com/assets/media/image/new-icon-6f488e9bf8b8e6684e84203f5f27dd8a.svg";